import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { memo } from 'react';

import { StyledBlink } from './TimeDisplay.style';

export const TimeDisplay = memo(function UtcDisplay({
    time,
    blink,
    timezone,
    undisplayedZone,
}: {
    time: number;
    blink: boolean;
    timezone?: string;
    undisplayedZone?: boolean;
}) {
    const zonedTime = utcToZonedTime(time, timezone || '');

    return (
        <>
            {format(zonedTime, 'HH')}
            {blink ? <StyledBlink>:</StyledBlink> : ':'}
            {format(zonedTime, 'mm')}
            &nbsp;
            {!undisplayedZone && (timezone === 'UTC' ? ' UTC' : ' LOCAL')}
        </>
    );
});
